/*! @azure/msal-browser v3.26.1 2024-10-08 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.26.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
